import PageHero from "@/components/PageHero";
import { useLanguage } from "@/i18n/LanguageContext";

const C = {
  ar: {
    eyebrow: "الأثر",
    title: "الأثر والإنجازات",
    lead: "منذ انطلاق المبادرة، عمل فريق SAS على تنفيذ محاضرات وورشات تعليمية ذات أثر عملي مباشر داخل جامعة حلب وخارجها، مع توسّع تدريجي في الوصول والتفاعل.",
    stats: [
      { v: "10", l: "محاضرة منفّذة" },
      { v: "4", l: "محاضرات داخل جامعة حلب" },
      { v: "6", l: "محاضرات خارج الجامعة" },
      { v: "~1000", l: "مشارك ومشاركة" },
      { v: "460", l: "في المحاضرات الجامعية الرئيسية" },
      { v: "95%", l: "معدّل رضا عام" },
    ],
    readingEyebrow: "قراءة الأرقام",
    readingBody: "يعكس هذا الأثر اهتمامًا متزايدًا من الطلاب والمهتمّين بأدوات الذكاء الاصطناعي وتطبيقاتها العملية، ويؤكّد الحاجة إلى تطوير هذا المسار وتوسيعه خلال المرحلة القادمة.",
  },
  en: {
    eyebrow: "Impact",
    title: "Impact and milestones",
    lead: "Since launching, the SAS team has delivered lectures and workshops with direct practical impact — inside and beyond the University of Aleppo — with steadily growing reach and engagement.",
    stats: [
      { v: "10", l: "Lectures delivered" },
      { v: "4", l: "Lectures at the University of Aleppo" },
      { v: "6", l: "Lectures outside the university" },
      { v: "~1000", l: "Participants" },
      { v: "460", l: "In the main university series" },
      { v: "95%", l: "Overall satisfaction" },
    ],
    readingEyebrow: "Reading the numbers",
    readingBody: "These figures reflect a rising interest among students and curious learners in AI tools and their practical applications — and make clear the need to expand and develop this path in the next phase.",
  },
};

export default function Impact() {
  const { lang } = useLanguage();
  const c = C[lang];

  return (
    <>
      <PageHero eyebrow={c.eyebrow} title={c.title} lead={c.lead} />
      <section className="sas-section" data-testid="impact-stats">
        <div className="sas-container">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-y-14 gap-x-10">
            {c.stats.map((s, i) => (
              <div key={s.l} className="border-t border-[color:var(--sas-line)] pt-6">
                <div className="text-xs text-[color:var(--sas-ink-2)] mb-3">{String(i + 1).padStart(2, "0")}</div>
                <div className="sas-stat"><span className={i === 0 ? "accent" : ""}>{s.v}</span></div>
                <div className="mt-3 text-sm text-[color:var(--sas-ink-2)]">{s.l}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <div className="sas-divider" />
      <section className="sas-section" data-testid="impact-supporting">
        <div className="sas-container max-w-3xl">
          <div className="sas-eyebrow mb-4">{c.readingEyebrow}</div>
          <p className="sas-h2">{c.readingBody}</p>
        </div>
      </section>
    </>
  );
}
